import { Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import RTTable from "../../components/Comman/RT/RTTable";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../components/withRouter";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import { stockHolderTargetJson } from "../../DynamicFormsJson/Transaction/stockholderTarget";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import StockHolderTargetViewTable from "./StockHolderTargetViewTable";
import { ConvertAmount } from "../../components/Comman/ConvertValueWithDenominator";

class StockHolderTargetView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			DataToSet: [],
			beatTargetList: [],
		};
	}
	async componentDidMount() {
		const { showLoador, showNotification } = this.props;
		if (navigator.onLine) {
			if (this.props.params.id) {
				showLoador({ loador: true });
				const response = await apiGet({
					url:
						stockHolderTargetJson.apiBaseURL +
						"/list-by-year-sequence-wise-optimize?yearId=" +
						this.props.params.id,
				});
				const { data, success } = response;
				if (success) {
					const stockHolderTargetData = data.data[0];
					const targetData = {
						yearName: stockHolderTargetData.yearName ?? "-",
						fromDate: stockHolderTargetData.yearFromDate ?? "-",
						toDate: stockHolderTargetData.yearToDate ?? "-",
					};

					let totalOfTarget = 0;

					const beatTargetList = data.data.map((item, index) => {
						totalOfTarget = totalOfTarget + +item.totalTarget;
						return {
							index: index + 1,
							id: item.id,
							regionName: item.regionName,
							stateName: item.stateName,
							zoneName: item.zoneName,
							areaName: item.areaName,
							beatName: item.beatName,
							jan: item.jan,
							feb: item.feb,
							march: item.march,
							april: item.april,
							may: item.may,
							jun: item.jun,
							july: item.july,
							aug: item.aug,
							sep: item.sep,
							oct: item.oct,
							nov: item.nov,
							dec: item.dec,
							months: item.months,
							totalTarget: item.totalTarget,
						};
					});
					const DataToSet = [
						{
							xs: 12,
							sm: 6,
							md: 6,
							lg: 6,
							label: "Year Name",
							value: targetData.yearName,
						},
						{
							xs: 12,
							sm: 6,
							md: 6,
							lg: 6,
							label: "From Date",
							value: targetData.fromDate,
						},
						{
							xs: 12,
							sm: 6,
							md: 6,
							lg: 6,
							label: "To Date",
							value: targetData.toDate,
						},
						{
							xs: 12,
							sm: 6,
							md: 6,
							lg: 6,
							label: "Total Target",
							value: ConvertAmount({ amount: totalOfTarget }),
						},
					];
					this.setState({ DataToSet, beatTargetList });
				} else {
					showNotification({ msg: serverMsg, severity: "error" });
				}
				showLoador({ loador: false });
			}
		} else {
			showNotification({ msg: noInternetMsg, severity: "error" });
		}
	}

	render() {
		const { DataToSet, beatTargetList } = this.state;

		return (
			<>
				<Paper
					sx={{
						p: 2,
						borderRadius: 0,
					}}
					elevation={0}
				>
					<DynamicFormWithoutSave
						showBackToList={true}
						DataToSet={DataToSet}
						showSaveBtn={stockHolderTargetJson.showSaveBtn}
						showTitle={true}
						screenTitle={"Stock Holder Target Assignation View"}
						fieldMeta={[]}
						showCancel={stockHolderTargetJson.showCancel}
						apiBaseURL={stockHolderTargetJson.apiBaseURL}
						showSaveNextBtn={stockHolderTargetJson.showSaveNextBtn}
						showSaveBtnMain={false}
						padding={true}
						paddingTop={true}
					/>

					<StockHolderTargetViewTable beatTargetList={beatTargetList} />
				</Paper>
			</>
		);
	}
}
const mapStateToProps = (state) => ({
	beatTargetList: state.beatTarget,
});
const mapDispatchToProps = {
	showNotification,
	showLoador,
};
export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(StockHolderTargetView);
